import { ILocalStore } from '@kts-front/types';

import { OpenStore } from 'stores/local/shared/OpenStore';

type LkLayoutStoreProps = {
  isDesktop: boolean;
};

export class LkLayoutStore implements ILocalStore {
  readonly menu: OpenStore;

  constructor({ isDesktop }: LkLayoutStoreProps) {
    this.menu = new OpenStore(isDesktop);
  }

  destroy() {
    this.menu.destroy();
  }
}
